import { render, staticRenderFns } from "./WorkPlanDays.vue?vue&type=template&id=715d35d7&"
import script from "./WorkPlanDays.vue?vue&type=script&lang=js&"
export * from "./WorkPlanDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports